import { type AxiosError } from 'axios'
import _get from 'lodash/get'

import { AUTHENTICATION_ERROR_NAME, HttpError } from './responses'

export const HTTP_CODE_UNAUTHORIZED = 401
export const HTTP_CODE_FORBIDDEN = 403
export const HTTP_CODE_NOT_FOUND = 404
export const HTTP_CODE_CONFLICT = 409

export function getErrorCode(error: AxiosError | HttpError | Error): number | undefined {
  if (error && _get(error, 'statusCode')) {
    return _get(error, 'statusCode')
  }

  if ('response' in error && error.response) {
    return error.response.status
  }

  return undefined
}

export function isForbiddenError(error: AxiosError | HttpError | Error) {
  const status = getErrorCode(error)
  return status === HTTP_CODE_FORBIDDEN
}

export function isUnauthorizedError(error: AxiosError | HttpError | Error) {
  const name = _get(error, 'name')
  if (name === AUTHENTICATION_ERROR_NAME) {
    return true
  }
  const status = getErrorCode(error)
  return status === HTTP_CODE_UNAUTHORIZED
}

export function isNotFoundError(error: AxiosError | HttpError | Error) {
  const status = getErrorCode(error)
  return status === HTTP_CODE_NOT_FOUND
}

export function isNetworkError(error: AxiosError | HttpError | Error) {
  if ('code' in error && error.code === 'ERR_NETWORK') {
    return true
  }

  const message = _get(error, 'message', '')
  return message === 'Network Error'
}
